import { render, staticRenderFns } from "./EducationalGroupAttendances.vue?vue&type=template&id=65dc4126&"
import script from "./EducationalGroupAttendances.vue?vue&type=script&lang=js&"
export * from "./EducationalGroupAttendances.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports